/**
 * Fixes UTF-8 encoding issues in strings where UTF-8 characters 
 * were incorrectly interpreted as Latin-1/ISO-8859-1
 * 
 * Example: "CÃ³digo" becomes "Código"
 */
export function fixEncoding(text: string): string {
  try {
    // Check if the string has encoding issues
    // Common pattern: accented characters appear as two strange characters
    if (!/[ÃÂ][¡-ÿ]/.test(text)) {
      return text;
    }

    // Convert the incorrectly decoded string back to bytes
    const bytes = new Uint8Array(text.length);
    for (let i = 0; i < text.length; i++) {
      bytes[i] = text.charCodeAt(i);
    }

    // Decode as UTF-8
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  } catch (error) {
    // If anything fails, return the original text
    return text;
  }
}

/**
 * Recursively fixes encoding issues in all strings within an object
 */
export function fixEncodingInObject(obj: any): any {
  if (typeof obj === 'string') {
    return fixEncoding(obj);
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => fixEncodingInObject(item));
  }
  
  if (obj !== null && typeof obj === 'object') {
    const fixed: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        fixed[key] = fixEncodingInObject(obj[key]);
      }
    }
    return fixed;
  }
  
  return obj;
}

